module.exports = __webpack_public_path__ + "img/3-(4).49998232.jpg";